import PubSub from "underpub-js";

var NavSelector = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

/**
 * Init
 * @return {[type]} [description]
 */
NavSelector.prototype.init = function(){

  var self = this;

  PubSub.subscribe("showNavSelector", function(options){

    self.options.$el.css({
      top: options.offset.top + 45,
      left: options.offset.left - 23
    });

    self.show();

  });

  PubSub.subscribe("hideNavSelector", function(options){
    self.hide();
  });

  this.options.$el.on("mouseenter", function(){
    PubSub.publish("enterNavSelector");
  });

  this.options.$el.on("mouseleave", function(){
    PubSub.publish("leaveNavSelector");
  });

};

/**
 * Showing the selector
 * @return {[type]} [description]
 */
NavSelector.prototype.show = function(){

  this.options.$el.addClass("is-active");

}

/**
 * Hiding the nav selector
 * @return {[type]} [description]
 */
NavSelector.prototype.hide = function(){

  this.options.$el.removeClass("is-active");

}

export default  NavSelector;
